module.exports = __webpack_public_path__ + "static/media/otherDoc.d5372894.png";